<template>
  <div>
    <div :class="data.class" class="text-input">
      <table>
        <tr>
          <td style="width: 200px">{{ data.label }}
            <footnotes :all-footnotes="footnotes" :local-footnotes="data.props.footnotes"></footnotes>
          </td>
          <td>
            <p type="text">{{ data.props.defaultValue }}</p>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import Footnotes
  from "./Footnotes.vue"

export default {
  name: 'INPUT',
  components: {Footnotes},
  props: ['data', 'footnotes'],
}
</script>



// WEBPACK FOOTER //
// INPUT.vue?567849f0